import { pluralize } from 'utils'
import Styles from './ChatInput.module.scss'
import { Credits } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'

type Props = {
  estimate: number
}

export const CreditEstimate = (props: Props) => {
  const { estimate } = props

  return (
    <div className={Styles.creditEstimate}>
      <Text variant="metadata" color="var(--dark-40)">
        {estimate} {pluralize('credit', estimate)}
      </Text>
      <Credits size={16} color="var(--dark-40)" />
    </div>
  )
}
